import { useLocation, useNavigate } from 'react-router-dom';
import { useCallback, useEffect, useRef } from 'react';
import { Logger } from '../../config/logging/logger';

export function useSafeBack(defaultPath = '/', searchExitPath = '/') {
  const navigate = useNavigate();
  const location = useLocation();
  const logger = Logger.create('useSafeBack');
  const previousPath = useRef<string | null>(null);

  useEffect(() => {
  // Save the previous path
    previousPath.current = location.pathname + location.search;
  }, [location]);

  const handleBack = useCallback(() => {
    // Case 1: Special handling if previous path was "/?search"
    const prev = previousPath.current;
    if (prev?.startsWith('/search?')) {
      navigate(searchExitPath, { replace: true });
      return;
    }

    // Case 2: First page load with no history or came from external place
    const isInitialEntry = window.history.length <= 1;

    if (isInitialEntry) {
      // {replace: true} will clear the history stack to prevent going back to external place
      navigate(defaultPath, { replace: true });
    } else {
      navigate(-1);
    }
  }, [navigate, defaultPath, searchExitPath]);

  return () => {
    logger.debug(Logger.format('useSafeBack', window.history.length <= 1, window.location.origin, previousPath.current));
    handleBack();
  };
}
